import React from "react";

const approachContent = [
  {
    subTitle: "ONE",
    title: "Erstkontakt",
    descriptions: `Wir telefonieren und besprechen erstmal Ihre Ziele und Pain-Points. Dabei sprechen wir gleich darüber, welche Synergien wir gemeinsam finden und entwickeln können.`,
    delayAnimation: "0",
  },

  {
    subTitle: "TWO",
    title: "Vor-Ort-Termin",
    descriptions: `Dabei zeigen wir Ihnen erstmal eine Demo-Anwendung, damit Sie selbst die Vorbestellungssoftware testen können. Dann schauen wir uns auch gleich Ihr vorhandenes Setup an und besprechen, wie wir gemeinsam weiter machen können. Wir nehmen Ihnen auch schon Demo-Marketing-Material mit, bei dem Sie uns sagen können, was Sie möchten und in welcher Form.`,
    delayAnimation: "100",
  },
  {
    subTitle: "THREE",
    title: "Angebot",
    descriptions: `Wir bereiten ein Angebot vor, dass genau auf Ihre Ziele, Pain-Points und Ihr Ladengeschäft maßgeschneidert ist.`,
    delayAnimation: "200",
  },
  {
    subTitle: "FOUR",
    title: "Sie entscheiden",
    descriptions: `wollen Sie mit uns Ihr Unternehmen digitalisieren und Ihren Kunden mehrwert bieten oder lieber nicht`,
    delayAnimation: "300",
  },
  {
    subTitle: "FIVE",
    title: "Integration",
    descriptions: ` Sie haben sich für uns entschieden! Wir stimmen gemeinsam zwei Termine ab: Bei dem ersten installieren wir alles und integrieren die Vorbestellungssoftware und geben Ihnen die Marketing-Materialien an die Hand. Im zweiten Termin bekommen Ihre Mitarbeiter eine kurze Schulung der Software, das dauert nicht lange, da wir Wert auf intuitive Bedienung legen.`,
    delayAnimation: "400",
  },
  {
    subTitle: "SIX",
    title: "Partnerschaft",
    descriptions: `Wir unterstützen Sie bei Fragen und Supportfällen um den Betrieb optimal zu gestalten`,
    delayAnimation: "500",
  },
];

const Approach = () => {
  return (
    <div
      className="row"
      style={{
        "--bs-gutter-x": "3.75rem",
        "--bs-gutter-y": "7.5rem",
      }}
    >
      {approachContent.map((val, i) => (
        <div className="col-xl-4 col-lg-6" key={i}>
          {/* <!--Animated Block--> */}
          <div
            className="ptf-animated-block"
            data-aos="fade"
            data-aos-delay={val.delayAnimation}
          >
            {/* <!--Approach Box--> */}
            <div
              className="ptf-approach-box"
              style={{
                "--ptf-title-color": "var(--ptf-color-white)",
              }}
            >
              <div className="ptf-approach-box__subtitle">{val.subTitle}</div>
              <h3 className="ptf-approach-box__title h1">{val.title}</h3>
              <div className="ptf-approach-box__content">
                <p>{val.descriptions}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Approach;
